"use strict";

require("core-js/modules/es6.array.index-of");

require("core-js/modules/es6.object.assign");

exports.__esModule = true;
exports.trackCheckout_GTM = exports.trackPurchase_GTM = exports.trackStdEcommerce_GTM = exports.trackInitiateRefundCancel_GTM = exports.trackRefundCancel_GTM = exports.trackRemoveFromCart_GTM = exports.trackAddToCart_GTM = exports.trackProductDetails_GTM = exports.trackProductClicks_GTM = exports.storeInLocalStorage = exports.STORAGE_REFUND_TRANSACTION_KEY = exports.STORAGE_TRANSACTION_KEY = void 0;

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
} //Standard Ecommerce


var STD_ECOMMERCE_TRANSACTION = 'std-ecommerce-transaction'; //EEC

var PRODUCT_SELECTED = 'eec-select-product';
var PRODUCT_DETAIL_VIEWED = 'eec-view-product-detail';
var PRODUCT_ADDED_TO_CART = 'eec-add-to-cart';
var REMOVE_FROM_CART = 'eec-remove-from-cart';
var INITIATE_CHECKOUT = 'eec-checkout';
var SUCCESSFUL_PURCHASE = 'eec-purchase';
var REFUND_CANCEL = 'eec-refund-cancel';
var INITIATE_REFUND_CANCEL = 'eec-initiate-refund-cancel'; //Others

var CURRENCY_PHP = 'PHP';
var STORAGE_TRANSACTION_KEY = 'ace-purchaseTransaction';
exports.STORAGE_TRANSACTION_KEY = STORAGE_TRANSACTION_KEY;
var STORAGE_REFUND_TRANSACTION_KEY = 'ace-refundTransaction';
exports.STORAGE_REFUND_TRANSACTION_KEY = STORAGE_REFUND_TRANSACTION_KEY;

var isInLocalStorage = function isInLocalStorage(transactionCode, storageKey) {
  var transactionList = localStorage.getItem(storageKey) || JSON.stringify([]);
  return transactionList.indexOf(transactionCode) !== -1;
};

var storeInLocalStorage = function storeInLocalStorage(transactionCode, storageKey) {
  var transactionList = localStorage.getItem(storageKey) || JSON.stringify([]);
  transactionList = JSON.parse(transactionList);
  transactionList.push(transactionCode);
  localStorage.setItem(storageKey, JSON.stringify(transactionList));
};

exports.storeInLocalStorage = storeInLocalStorage;

var gtmInvoker = function gtmInvoker(gtmFunction, callback) {
  if (!window['google_tag_manager']) {
    if (callback) {
      // console.log('GTM callback')
      callback();
    }
  } else {
    gtmFunction();
  }
};

var trackProductClicks_GTM = function trackProductClicks_GTM(itemArray, listName, callback) {
  gtmInvoker(function () {
    window.dataLayer.push({
      'event': PRODUCT_SELECTED,
      'ecommerce': {
        'click': {
          'actionField': {
            'list': listName
          },
          'products': itemArray
        }
      },
      'label': '',
      'value': '',
      'eventCallback': callback(),
      'eventTimeout': 2000
    });
  }, callback);
};

exports.trackProductClicks_GTM = trackProductClicks_GTM;

var trackProductDetails_GTM = function trackProductDetails_GTM(itemArray, callback) {
  gtmInvoker(function () {
    window.dataLayer.push({
      'event': PRODUCT_DETAIL_VIEWED,
      'ecommerce': {
        'detail': {
          'products': itemArray
        }
      },
      'label': '',
      'value': '',
      'eventCallback': callback(),
      'eventTimeout': 2000
    });
  }, callback);
};

exports.trackProductDetails_GTM = trackProductDetails_GTM;

var trackAddToCart_GTM = function trackAddToCart_GTM(itemArray) {
  gtmInvoker(function () {
    window.dataLayer.push({
      'event': PRODUCT_ADDED_TO_CART,
      'ecommerce': {
        'add': {
          'products': itemArray
        }
      },
      'label': '',
      'value': ''
    });
  }, null);
};

exports.trackAddToCart_GTM = trackAddToCart_GTM;

var trackRemoveFromCart_GTM = function trackRemoveFromCart_GTM(itemArray) {
  gtmInvoker(function () {
    window.dataLayer.push({
      'event': REMOVE_FROM_CART,
      'ecommerce': {
        'remove': {
          'products': itemArray
        }
      },
      'label': '',
      'value': ''
    });
  }, null);
};

exports.trackRemoveFromCart_GTM = trackRemoveFromCart_GTM;

var trackRefundCancel_GTM = function trackRefundCancel_GTM(transactionId, itemArray) {
  //if array empty cancel entire transaction
  gtmInvoker(function () {
    if (!isInLocalStorage(transactionId, STORAGE_REFUND_TRANSACTION_KEY)) {
      var theItemArray = itemArray.length > 0 ? {
        'products': itemArray
      } : {};
      window.dataLayer.push({
        'event': REFUND_CANCEL,
        'label': transactionId,
        'ecommerce': {
          'refund': _extends({
            'actionField': {
              'id': transactionId
            }
          }, theItemArray)
        },
        value: '',
        'eventCallback': function eventCallback() {
          storeInLocalStorage(transactionId, STORAGE_REFUND_TRANSACTION_KEY);
        },
        'eventTimeout': 2000
      });
    }
  });
};

exports.trackRefundCancel_GTM = trackRefundCancel_GTM;

var trackInitiateRefundCancel_GTM = function trackInitiateRefundCancel_GTM(transactionId, callback) {
  gtmInvoker(function () {
    var _window$dataLayer$pus;

    window.dataLayer.push((_window$dataLayer$pus = {
      'event': INITIATE_REFUND_CANCEL,
      'action': 'Initiate Return/Exchange',
      'label': transactionId,
      'eventCallback': function eventCallback() {
        callback();
      }
    }, _window$dataLayer$pus["label"] = transactionId, _window$dataLayer$pus.value = '', _window$dataLayer$pus['eventTimeout'] = 2000, _window$dataLayer$pus));
  }, callback);
};

exports.trackInitiateRefundCancel_GTM = trackInitiateRefundCancel_GTM;

var trackStdEcommerce_GTM = function trackStdEcommerce_GTM(transactionId, totalCost, shipping, itemArray) {
  gtmInvoker(function () {
    if (!isInLocalStorage(transactionId, STORAGE_TRANSACTION_KEY) && window.dataLayer) {
      window.dataLayer.push({
        'event': STD_ECOMMERCE_TRANSACTION,
        'transactionId': transactionId,
        'currencyCode': CURRENCY_PHP,
        'transactionAffiliation': 'ACE Hardware',
        'transactionTotal': totalCost,
        'transactionShipping': shipping,
        'transactionProducts': itemArray,
        'eventCallback': function eventCallback() {
          storeInLocalStorage(transactionId, STORAGE_TRANSACTION_KEY);
        },
        'eventTimeout': 2000,
        'label': '',
        'value': ''
      });
    }
  });
};

exports.trackStdEcommerce_GTM = trackStdEcommerce_GTM;

var trackPurchase_GTM = function trackPurchase_GTM(transactionId, totalCost, shipping, itemArray) {
  gtmInvoker(function () {
    if (!isInLocalStorage(transactionId, STORAGE_TRANSACTION_KEY)) {
      window.dataLayer.push({
        'event': SUCCESSFUL_PURCHASE,
        'ecommerce': {
          'currencyCode': CURRENCY_PHP,
          'purchase': {
            'actionField': {
              'id': transactionId,
              // Transaction ID. Required for purchases and refunds.
              'revenue': totalCost,
              // Total transaction value (incl. tax and shipping)
              'shipping': shipping //   'coupon': coupon,

            },
            'products': itemArray
          }
        },
        label: transactionId,
        value: totalCost,
        'eventCallback': function eventCallback() {
          storeInLocalStorage(transactionId, STORAGE_TRANSACTION_KEY);
        },
        'eventTimeout': 2000
      });
    }
  });
};

exports.trackPurchase_GTM = trackPurchase_GTM;

var trackCheckout_GTM = function trackCheckout_GTM(itemArray, callback) {
  gtmInvoker(function () {
    window.dataLayer.push({
      'event': INITIATE_CHECKOUT,
      'ecommerce': {
        'checkout': {
          'actionField': {
            'step': 1,
            'option': 'initiate checkout'
          },
          'products': itemArray
        },
        'label': '',
        'value': '',
        'eventCallback': callback(),
        'eventTimeout': 2000
      }
    });
  }, callback);
};

exports.trackCheckout_GTM = trackCheckout_GTM;